import capitalize from '~/helpers/capitalize-helpers';
export default ((context, inject) => {
  inject('capitalize', capitalize);
});